'use client';
import qs from 'qs';
export default function removeQueryParams(paramsToRemove: string[]): void {
    // Remove the ? otherwise it ends up in an object key.
    if (!(window as any).history) return;
    const params = qs.parse(window.location.search.replace('?', ''));
    for (const param of paramsToRemove) {
        delete params[param];
    }
    const currentPath = window.location.pathname;
    let pushURL = window.location.pathname;
    if (Object.keys(params).length) {
        pushURL += `?${qs.stringify(params)}`;
    }
    if (currentPath != pushURL) {
        history.pushState(null, '', pushURL);
    }
}
